import classnames from 'classnames';
import {getSetting} from '@woocommerce/settings'

/**
 * Generalized tokenized payment method component
 * Can be used by any payment integration (Fastlane, Google Pay, etc.)
 */
export const TokenizedPaymentMethod = (
    {
        alt,
        brand,
        description,
        actions = [],
        className = ''
    }
) => {
    const icons = getSetting('stripeGeneralData').cardIcons;
    return (
        <div className={classnames('wc-stripe-tokenized-card', className)}>
            {brand && (
                <CardIcon alt={alt} src={icons[brand]}/>
            )}
            <div className="wc-stripe-tokenized-card-format">
                {description}
            </div>
            {actions.length > 0 && (
                <div className="wc-stripe-tokenized-card-actions">
                    {actions.map((action, index) => (
                        <a
                            key={index}
                            className={`wc-stripe-tokenized-card-${action.type || 'action'}`}
                            onClick={action.onClick}>
                            {action.label}
                        </a>
                    ))}
                </div>
            )}
        </div>
    )
}

const CardIcon = ({src, alt}) => {
    return (
        <div className="wc-stripe-tokenized-card-icon-container">
            <img src={src} alt={alt || ''}/>
        </div>
    )
}

export default TokenizedPaymentMethod;